/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Select_Folder_ButtonInputs */

const en_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Folder`)
};

const fr_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un dossier`)
};

const de_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordner auswählen`)
};

const it_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona cartella`)
};

const ru_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите папку`)
};

const es_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar carpeta`)
};

const zh_cn2_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择文件夹`)
};

const ja_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダを選択`)
};

const hi_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर चुनें`)
};

const pt_pt2_audio_description_export_select_folder_button = /** @type {(inputs: Audio_Description_Export_Select_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar pasta`)
};

/**
* | output |
* | --- |
* | "Select Folder" |
*
* @param {Audio_Description_Export_Select_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_select_folder_button = /** @type {((inputs?: Audio_Description_Export_Select_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Select_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_select_folder_button(inputs)
	if (locale === "de") return de_audio_description_export_select_folder_button(inputs)
	if (locale === "it") return it_audio_description_export_select_folder_button(inputs)
	if (locale === "ru") return ru_audio_description_export_select_folder_button(inputs)
	if (locale === "es") return es_audio_description_export_select_folder_button(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_select_folder_button(inputs)
	if (locale === "ja") return ja_audio_description_export_select_folder_button(inputs)
	if (locale === "hi") return hi_audio_description_export_select_folder_button(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_select_folder_button(inputs)
	return en_audio_description_export_select_folder_button(inputs)
});